import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M19.5 15h-3c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3c.276 0 .5.224.5.5s-.224.5-.5.5zM12.5 15h-7c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5s.5.224.5.5V14h6.5c.276 0 .5.224.5.5s-.224.5-.5.5zM5.5 4c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5s.5.224.5.5v3c0 .276-.224.5-.5.5z',
    'M14.5 20c-.276 0-.5-.224-.5-.5V6H.5C.224 6 0 5.776 0 5.5S.224 5 .5 5h14c.276 0 .5.224.5.5v14c0 .276-.224.5-.5.5z',
  ],
  height: 20,
  width: 20,
});
